import { gql } from '@apollo/client'

export const GET_DISCIPLINES_SPECIALTIES_QUERY = gql`
	query getProfileQuery {
		worker {
			workerDisciplineSpecialties {
				id
				discipline {
					disciplineName
					disciplineType
					id
					hasSkillChecklist
				}
				specialty {
					name
					id
					hasSkillChecklist
				}
				isPrimary
			}
		}
	}
`
